import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Message queue icon.
 *
 * A rounded rectangle representing a queue/message buffer, with a
 * horizontal divider line and a small filled dot on the left side
 * representing a queued message.
 *
 * Dual-tone layered:
 * - Outlines: currentColor, 2px stroke, round caps/joins
 * - Rect body: cyan accent fill at 8%
 * - Message dot: solid currentColor fill
 */
export const QueueIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size}>
    {/* Rounded rectangle body with cyan accent fill */}
    <rect
      x="3"
      y="5"
      width="18"
      height="14"
      rx="3"
      fill="#00d4ff"
      fillOpacity={0.08}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Horizontal divider line */}
    <path
      d="M3 12 L21 12"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Small filled message dot on the left side */}
    <circle cx="7" cy="8.5" r={1.5} fill="currentColor" />
  </RushaSvgIcon>
);

QueueIcon.displayName = "QueueIcon";

export default QueueIcon;
